import Footer from './Footer';
import consultImage from '../assets/supply1.webp'; // Ensure you have the correct path for your image

export default function OHSConsulting() {
  return (
    <div className='md:mt-[10px] mt-[100px]'>
      <img
        src={consultImage}
        alt="Consulting Image"
        className="w-full h-[200px] md:h-[500px] object-cover"
      />

      <div className="bg-white p-12 text-center bg-inspiration-geometry">
        <h2 className="text-4xl font-maiandra mb-4">Occupational Safety Gear & Equipmentg</h2>
        <p className="text-gray-700 lg:ml-[33%] md:ml-[15%] font-myraid max-w-lg">
         <b>Mission :</b> 
         To provide high-quality, reliable occupational safety products that
         meet international safety standards and help protect the workforce.        </p>

        <br></br><br></br><br></br><br></br>

        <h2 className="text-4xl font-maiandra mb-4">What We Do</h2>
        <br></br>
        <ul className="list-none pl-0 md:pl-32 mb-6 text-left lg:text-center text-gray-900 space-y-1">
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Supply of Personal Protective Equipment (PPE), including helmets, gloves, goggles, face shields, high-visibility clothing, respiratory protection, and footwear.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Specialized equipment for industry-specific needs, including construction, mining, manufacturing, healthcare, and public sectors.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Safety signage, hazard identification solutions, and emergency response tools.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Customization services for branded or industry-specific PPE solutions.</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Equipment maintenance and inspection services to ensure compliance
          with safety regulations.</li>
        </ul>

        <br></br><br></br><br></br><br></br>

        <div className="p-1 md:p-8">
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-900 p-6 text-white rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra mb-4">Best Practices</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>ourcing from internationally certified manufacturers that adhere to ISO, CE, and OSHA standards.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Establishing partnerships with global leaders in occupational safety equipment.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Providing user training and after-sale support to ensure the correct and effective use of safety gear.</li>
              </ul>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra text-white mb-4">Key Strengths</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>High-quality, reliable products that meet or exceed global standards.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Focused on customer education and safety compliance.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Comprehensive range of products to address diverse industry needs</li>
              </ul>
            </div>
          </div>
          <br></br><br></br>
        </div>
      </div>

      <Footer />
    </div>
  );
}
